module.exports = __webpack_public_path__ + "assets/fee17c09fff993d70318335a19df7e98.png";